import { Auth_Check , Refresh_Token} from "../action/action";

const initialState = {
    isLoggedIn: false,
    token: '',
    userInfo:'',
    refreshToken: '',
};

// AuthReducer Function
const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case Auth_Check:
            return { ...state, isLoggedIn: action.isAuth, token: action.token, userInfo: action.userInfo};
        case Refresh_Token:
            return { ...state, refreshToken: action.refreshToken};
        default:
            return state;
    }
}

export default authReducer;